import styled from 'styled-components';
import { theme } from '../../theme';

export const DivTableSubheader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${theme.up(theme.breakpoints.sm)} {
    flex-direction: row;
    align-items: center;
  }
`;

export const DivRight = styled.div`
  padding: 0.769rem 0;
`;
